
          <div class="popover__wrapper">
            <a  class="cartIcon">
              <img src="{{globalService.staticResourceURL}}/assets/images/Group.svg" class="img-fluid">
              <div [style.background-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">{{itemCount || 0}}</div>
            </a>
            <div class="popover__content" *ngIf="itemCount>0">
              
              <div class="col-12 no-padding popover-brdr-btm"   *ngFor="let dmvRegistration of _registrationsInCart; let i = index">
                <div class="row no-margin">
                  <div class="col-6 overlaycart-txt" >
                    <span (click)="editRegistration(i, $event)">{{dmvRegistration?.registration?.licensePlate}}</span>
                  </div>
                  <div class="col-6 overlaycart-value" >
                    <span  (click)="editRegistration(i, $event)">{{dmvRegistration?.registration?.totalAmountDue | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</span>
                  </div>
                </div>
              </div>
               <div class="col-12 no-padding popover-brdr-btm"   *ngFor="let dmvRegistrationManual of dmvStoreService.registrationsInCart.dmvRegistrationsManual; let i = index">
                <div class="row no-margin">
                  <div class="col-6 overlaycart-txt" >
                    <span (click)="editManualRenew(i, $event)">{{dmvRegistrationManual?.tagNumber}}</span>
                  </div>
                  <div class="col-6 overlaycart-value" >
                    <span (click)="editManualRenew(i, $event)">{{(dmvRegistrationManual?.amount + dmvRegistrationManual?.lateFee) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</span>
                  </div>
                </div>
              </div>
  
              <div class="col-12 no-padding popover-brdr-btm"   *ngFor="let dmvRegistrationsDuplicate of dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate; let i = index">
                <div class="row no-margin">
                  <div class="col-6 overlaycart-txt" >
                    <span (click)="editDuplicateRenew(i, $event)">{{dmvRegistrationsDuplicate?.tagNumber}}</span>
                  </div>
                  <div class="col-6 overlaycart-value" >
                    <span (click)="editDuplicateRenew(i, $event)">{{(dmvRegistrationsDuplicate.dmvCostData.totalAmountDue) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</span>
                  </div>
                </div>
              </div>


              <div class="col-12 no-padding popover-brdr-btm" *ngIf="this.dmvStoreService.registrationsInCart.donation">
                <div class="row no-margin">
                  <div class="col-6 overlaycart-txt">
                    <span  (click)="editDonation($event)">Donation</span>
                  </div>
                  <div class="col-6 overlaycart-value">
                    <span  (click)="editDonation($event)">{{this.dmvStoreService.registrationsInCart?.donation?.amount | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</span>
                  </div>
                </div>
              </div>
  
              <div class="col-12 no-padding popover-brdr-btm">
                <div class="row no-margin">
                  <div class="col-6 overlaycart-total no-hover">
                    <span>TOTAL</span>
                  </div>
                  <div class="col-6 overlaycart-value no-hover">
                    <span>{{total | currency :'USD':'symbol':'1.2-2' | minusSignToParens}}</span>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
       